<mat-sidenav-container autosize class="bg-primary" style="height: 100vh;">
    <!-- Menu lateral esquerdo -->
    <mat-sidenav #sidenav [mode]="isMobile ? 'over' : 'side'" [opened]="!isMobile || isExpanded" position="start"
        fixedInViewport="true" class="menu-lateral" [ngClass]="{ 'expanded': isExpanded, 'collapsed': !isExpanded }">
        <!-- Conteúdo do menu -->

        <div class="content-sidenav  bg-primary border-none">
            <!-- Cabeçalho do menu -->
            <div class="cabecalho w-full flex-center flex-justify-between "
                [ngClass]="{ 'justify-between': isExpanded, 'justify-center': !isExpanded }">
                <img (click)="home()" style="cursor: pointer;" class="w-120 h-40" *ngIf="isExpanded"
                    src="assets/ondetah.svg" alt="uma imagem" />

                <button
                    class="menu-btn justify-between w-30 u-bg-transparent u-border-white u-text-white flex-center h-30"
                    style="color: #FFF; border: none;" (click)="toggleSidenav()" aria-label="Toggle sidenav">
                    <span class="material-symbols-outlined icon-rotate" [class.rotated]="isExpanded">
                        double_arrow
                    </span>

                </button>

                <!-- <button *ngIf="isExpanded" class=" h-30 flex-center w-full"
                    style="color: #FFF; border: none; justify-content: flex-end; display: flex;"
                    (click)="toggleSidenav()" aria-label="Toggle sidenav">
                    <span class="material-symbols-outlined">
                        arrow_menu_close
                    </span>
                </button> -->
            </div>
            <div class="w-full container-menus ">
                <app-menus (menuSelecionado)="isExpanded = true" (fecharMenu)="toggleSidenav()"
                    [MenuExpandido]="isExpanded"></app-menus>
            </div>
        </div>
    </mat-sidenav>

    <mat-sidenav #drawerFiltros mode="over" position="end" class="drawer-filtro"
        [opened]="filtroAberto || filtroPedidosAberto || notificacaoAberta || filtroAvaliacaoAberto" (closedStart)="fecharDrawer()">

        <!-- Filtro normal -->
        <div class="w-full h-full" [hidden]="!filtroAberto">
            <app-filtro-desktop></app-filtro-desktop>
        </div>
        
        <!-- Filtro avaliacao -->
        <div class="w-full h-full" [hidden]="!filtroAvaliacaoAberto">
            <app-filter-avaliacao></app-filter-avaliacao>
        </div>

        <!-- Filtro de pedidos -->
        <div class="h-full w-full" [hidden]="!filtroPedidosAberto">
            <app-filter-consulta-pedidos></app-filter-consulta-pedidos>
        </div>

        <!-- Notificações -->
        <div class="h-full w-full" [hidden]="!notificacaoAberta">
            <app-notificacao-bar></app-notificacao-bar>
        </div>

    </mat-sidenav>



    <!-- Conteúdo principal -->
    <mat-sidenav-content>
        <mat-toolbar class="header bg-gradient" style="position: fixed; top: 0; left: 0; right: 0; z-index: 100;">
            <div class="header-container">
                <div class="openMenuMobile">
                    <button *ngIf="!isExpanded" class="justify-between flex-center h-30 flex-center"
                        style="color: #FFF; border: none;" (click)="toggleSidenav()" aria-label="Toggle sidenav">
                        <mat-icon>segment</mat-icon>
                    </button>
                    <button *ngIf="isExpanded" class=" h-30 flex-center w-full"
                        style="color: #FFF; border: none; justify-content: flex-end; display: flex;"
                        (click)="toggleSidenav()" aria-label="Toggle sidenav">
                        <mat-icon>segment</mat-icon>
                    </button>
                </div>
                <img (click)="home()" style="cursor: pointer;" class="w-120 h-40 image-mobile" src="assets/ondetah.svg"
                    alt="uma imagem" />
                <app-user-profile-header class="w-auto"></app-user-profile-header>
            </div>
        </mat-toolbar>

        <div>
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
